import { render, staticRenderFns } from "./UpdateEventVoucher.vue?vue&type=template&id=36bcb2b1"
import script from "./UpdateEventVoucher.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateEventVoucher.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports